<template>
    <div v-if="loadingLayersList">
        <NavBar shared="true" noleft="true" />
        <LayerView :project_id="project_id" />
    </div>
</template>

<script>

import NavBar       from "../NavBar";
import LayerView    from "../PSComponents/LayerView";

export default {
    name: "ProjectView",
    props: ['project_id'],
    data () {
        return {
            loadingLayersList: false,
            items: []
        }
    },
    computed:{
        shared_layers () {
            return this.$store.getters.shared_layers;
        }
    },
    components:{
        NavBar,
        LayerView
    },
    created() {
        this.$vuetify.theme.dark = true;

        this.$store.dispatch('getSharedLayers', {slugid: this.project_id, password: ''})
        .then(() => {
            if (this.shared_layers.length != 0){
                let cnt = 0;
                for (let layer in this.shared_layers){
                    if (this.shared_layers[layer].count_panorama_files != 0 || this.shared_layers[layer].count_image_files != 0){
                        this.items.push({name: this.shared_layers[layer].name, id: this.shared_layers[layer].id, layer});
                    }
                    else{
                        delete(this.shared_layers[layer]);
                    }
                }
                if (this.items.length == 0) this.$router.push('/no_data');
                else{
                    this.$store.dispatch('setSharedNotEmpty', this.items);
                    this.loadingLayersList = true;
                }
            }
            else{
                this.$router.push('/no_data');
            }
        })
        .catch(() => {});
    }
};
</script>
